module.exports = __webpack_public_path__ + "img/cloud_tool_hot.16bdc988.jpg";